<template>
    <div class="ques-tips-wrapper" v-show="questionName" :style="styles" @mouseover="mouseOverHandler" @mouseout="mouseOutHandler">
        {{ questionName }}
        <div v-show="message.questionId" class="jump-newpage" @click="goQuestionEdit">{{ $t("zhiji.answer.viewCompleteContent") }}</div>
    </div>
</template>

<script>
import { queryQuestionDetail } from "@/views/zhiji/js/services/service.js";

export default {
    name: "Tips",
    props: ["message", "position", "algin"],
    data() {
        return{
            questionName: "",
        }
    },
    computed: {
        styles() {
            const { left, top, width, height } = this.position;
            if (this.algin === "middle" && this.$el) {
                return {
                    left: `${left - (this.$el.offsetWidth / 2 - width / 2)}px`,
                    top: `${top + height}px`
                };
            }
            return {
                left: `${left}px`,
                top: `${top + height}px`
            };
        }
    },
    mounted() {
        queryQuestionDetail({ questionId: this.message.questionId }).then(res => {
            this.questionName = res.info.standQuestion;
        });
    },
    methods: {
        goQuestionEdit() {
            const that = this;
            this.zhiji.goQuestionEdit(that, this.message.questionId);
        },
        mouseOverHandler(event) {
            this.$emit("mouseover", event);
        },
        mouseOutHandler(event) {
            this.$emit("mouseout", event);
        }
    }
};
</script>

<style lang="less" scoped>
.ques-tips-wrapper {
    background: #333333;
    border-radius: 2px;
    font-size: 12px;
    padding: 6px;
    color: #fff;
    max-width: 450px;
    position: fixed;
    top: -9999px;
    left: -9999px;
    .jump-newpage {
        color: #26a2ff;
        cursor: pointer;
    }
}
</style>
